<template>
    <div class="wrap">
        <div class="top">
            <p>尊敬的用户，您好:</p>
            <p>感谢您使用联合信任的产品并选择开票服务，请查看并下载电子发票!</p>
        </div>
        <div class="content">
            <img :src="src">
        </div>
        <div class="downBtn">
            <span @click="downLoad(1)">
                <i class="el-icon-document"></i>
                发票下载PDF
            </span>
            <span @click="downLoad(2)">
                <i class="el-icon-document"></i>
                发票下载OFD
            </span>
            <span @click="downLoad(3)">
                <i class="el-icon-document"></i>
                发票下载XML
            </span>
        </div>
    </div>
</template>

<script>
import {getInvoiceUrl} from "@http/invoice/index";
export default {
    data () {
        return {
            invoiceUrl:{
                ofdUrl:'',
                xmlUrl:'',
                type:'',
            },
            src:'',
            invoiceCode:''
        }
    },
    components: {},
    computed: {},
    created() {
        this.invoiceCode =this.$route.query?.code;
        if(this.invoiceCode){
            this.init(this.invoiceCode)
        }else{
            this.$msg('参数丢失，请重新打开指定链接')
        }
        
    },
    mounted() {},
    methods: {
        init(invoiceCode){
            getInvoiceUrl(invoiceCode).then(res => {
                this.invoiceUrl=res;
                this.src=res.imgUrls;
            }).catch(err => {
                console.log(err);
            });
        },
        openWindow(url){
            let link = document.createElement("a");
            link.style.display = "none";
            link.target = "_blank";
            link.href = url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        downLoadByUrl(type){
            this.openWindow(`/invoice/api/invoice/v2/downloadInvoiceUrl/${this.invoiceCode}/${type}`)
        },
        downLoad(n){
            if(n==1){
                this.downLoadByUrl('pdf')
            }else if(n==2){
                if(this.invoiceUrl.type==2){//数电
                    this.downLoadByUrl('ofd')
                }else{//老版纸质和电子
                    this.$msg('当前发票不支持此类型下载')
                }
            }else{
                if(this.invoiceUrl.type==2){//数电
                    if(this.invoiceUrl.xmlUrl){
                        this.downLoadByUrl('xml')
                    }else{
                        getInvoiceUrl(this.invoiceCode).then(res => {
                            this.invoiceUrl=res;
                            if(!this.invoiceUrl.xmlUrl){
                                this.$msg('XML格式的发票还未生成，请稍后再试')
                            }else{
                                this.downLoadByUrl('xml')
                            }
                        }).catch(err => {
                            console.log(err);
                        });
                    }
                }else{//老版纸质和电子
                    this.$msg('当前发票不支持此类型下载')
                }
                
            }
        },
    },
}

</script>
<style scoped lang='less'>
.wrap{
    max-width: 750px;
    width: 100%;
    margin: 0 auto;
    .top{
        padding-top: 40px;
        p{
            margin-top:20px;
            font-size: 16px;
            color: #333;
            &:nth-child(2){
                text-indent: 2em;
            }
        }
    }
    .content{
        width: 100%;
        margin-top: 20px;
        border:1px solid #000;
        img{
            width: 100%;
        }
    }
    .downBtn{
        display: flex;
        justify-content: space-around;
        margin-top: 20px;
        span{
            cursor: pointer;
            font-size: 16px;
            color: #409EFF;
            display: flex;
            align-items: center;
            font-weight: bold;
            i{
                font-size: 30px;
                margin-right: 5px;
            }
            &:hover{
                color: #0576e7;
            }
        }
    }
}

@media screen and (max-width: 750px) {
    .wrap{
        padding: 0 20px;
        box-sizing: border-box;
    }
    .downBtn{
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        span{
            margin-bottom:30px;
        }
    }
}

</style>